export default __webpack_public_path__ + "static/media/profile-image.20ae80aa.png";